var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.element.type=='DNL-GALLERY')?_c('Gallery',{attrs:{"imgs":_vm.element.imgs,"title":_vm.element.title}}):_c('SimpleHtmlElement',{attrs:{"element":_vm.element}})}
var staticRenderFns = []

export { render, staticRenderFns }